import { default as indexzgxfwD0kuTMeta } from "/home/circleci/reflect-front/pages/benchmark/index.vue?macro=true";
import { default as _91measure_93VXrCQrbzbfMeta } from "/home/circleci/reflect-front/pages/dashboard/[dashboard]/benchmark/[measure].vue?macro=true";
import { default as _91measure_93G79vTddHDnMeta } from "/home/circleci/reflect-front/pages/dashboard/[dashboard]/explore/[measure].vue?macro=true";
import { default as index1J0xYE2FOgMeta } from "/home/circleci/reflect-front/pages/dashboard/[dashboard]/index.vue?macro=true";
import { default as _91dashboard_936wKoNLScojMeta } from "/home/circleci/reflect-front/pages/dashboard/[dashboard].vue?macro=true";
import { default as indexEqNkr6HvDCMeta } from "/home/circleci/reflect-front/pages/dashboard/index.vue?macro=true";
import { default as indexsnYi8bbFmMMeta } from "/home/circleci/reflect-front/pages/explore/index.vue?macro=true";
import { default as indexYYpM2aFs9gMeta } from "/home/circleci/reflect-front/pages/index.vue?macro=true";
import { default as editqS094a3Iu3Meta } from "/home/circleci/reflect-front/pages/legal-reports/[legalReport]/edit.vue?macro=true";
import { default as indexVc35Rq8SIJMeta } from "/home/circleci/reflect-front/pages/legal-reports/[legalReport]/index.vue?macro=true";
import { default as preview4onafmjZO2Meta } from "/home/circleci/reflect-front/pages/legal-reports/[legalReport]/preview.vue?macro=true";
import { default as _91legalReport_93KjSMLsVnhRMeta } from "/home/circleci/reflect-front/pages/legal-reports/[legalReport].vue?macro=true";
import { default as indexZHnjBIMOqBMeta } from "/home/circleci/reflect-front/pages/legal-reports/index.vue?macro=true";
import { default as indexHyN35IpB1cMeta } from "/home/circleci/reflect-front/pages/login/index.vue?macro=true";
import { default as ssoKYroWS8zycMeta } from "/home/circleci/reflect-front/pages/login/sso.vue?macro=true";
import { default as _91email_936xHEBDagKuMeta } from "/home/circleci/reflect-front/pages/reset-password/change/[email].vue?macro=true";
import { default as indexcBFBuzoMndMeta } from "/home/circleci/reflect-front/pages/reset-password/index.vue?macro=true";
import { default as indexK5SAeq8IBVMeta } from "/home/circleci/reflect-front/pages/settings/data-health/index.vue?macro=true";
import { default as indexra9eR3D3K4Meta } from "/home/circleci/reflect-front/pages/settings/data-mapping/index.vue?macro=true";
import { default as indexYWywmgAyP3Meta } from "/home/circleci/reflect-front/pages/settings/data-normalization/index.vue?macro=true";
import { default as indexSgNQroCHreMeta } from "/home/circleci/reflect-front/pages/settings/index.vue?macro=true";
import { default as index4bqKTtyFqMMeta } from "/home/circleci/reflect-front/pages/settings/integrations/index.vue?macro=true";
import { default as _91sourceId_93Xqxb6Vh4sfMeta } from "/home/circleci/reflect-front/pages/settings/integrations/sources/[sourceId].vue?macro=true";
import { default as integrationsS6r8LFTf3YMeta } from "/home/circleci/reflect-front/pages/settings/integrations.vue?macro=true";
import { default as preferences6CoJN9CK1dMeta } from "/home/circleci/reflect-front/pages/settings/my-account/preferences.vue?macro=true";
import { default as profilewjwOprCpePMeta } from "/home/circleci/reflect-front/pages/settings/my-account/profile.vue?macro=true";
import { default as access_45rolescfwvH074KbMeta } from "/home/circleci/reflect-front/pages/settings/permissions/access-roles.vue?macro=true";
import { default as data_45sensitivityI393D5VQHMMeta } from "/home/circleci/reflect-front/pages/settings/permissions/data-sensitivity.vue?macro=true";
import { default as source_45ownershipaVM5FWAbupMeta } from "/home/circleci/reflect-front/pages/settings/permissions/source-ownership.vue?macro=true";
import { default as indexYZmQJ5xQ2oMeta } from "/home/circleci/reflect-front/pages/settings/users/index.vue?macro=true";
import { default as preferencesu15mKM698IMeta } from "/home/circleci/reflect-front/pages/settings/workspace/preferences.vue?macro=true";
import { default as renamingTfPLK27slFMeta } from "/home/circleci/reflect-front/pages/settings/workspace/renaming.vue?macro=true";
import { default as _91email_93rfBluS5gs1Meta } from "/home/circleci/reflect-front/pages/signup/confirm/[email].vue?macro=true";
import { default as indexqSwOaqIg8sMeta } from "/home/circleci/reflect-front/pages/signup/index.vue?macro=true";
export default [
  {
    name: "benchmark",
    path: "/benchmark",
    meta: indexzgxfwD0kuTMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/benchmark/index.vue").then(m => m.default || m)
  },
  {
    name: _91dashboard_936wKoNLScojMeta?.name,
    path: "/dashboard/:dashboard()",
    meta: _91dashboard_936wKoNLScojMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/dashboard/[dashboard].vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-dashboard-benchmark-measure",
    path: "benchmark/:measure()",
    meta: _91measure_93VXrCQrbzbfMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/dashboard/[dashboard]/benchmark/[measure].vue").then(m => m.default || m)
  },
  {
    name: "dashboard-dashboard-explore-measure",
    path: "explore/:measure()",
    meta: _91measure_93G79vTddHDnMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/dashboard/[dashboard]/explore/[measure].vue").then(m => m.default || m)
  },
  {
    name: "dashboard-dashboard",
    path: "",
    component: () => import("/home/circleci/reflect-front/pages/dashboard/[dashboard]/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexEqNkr6HvDCMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: "explore",
    path: "/explore",
    meta: indexsnYi8bbFmMMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/explore/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexYYpM2aFs9gMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91legalReport_93KjSMLsVnhRMeta?.name,
    path: "/legal-reports/:legalReport()",
    meta: _91legalReport_93KjSMLsVnhRMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/legal-reports/[legalReport].vue").then(m => m.default || m),
    children: [
  {
    name: "legal-reports-legalReport-edit",
    path: "edit",
    meta: editqS094a3Iu3Meta || {},
    component: () => import("/home/circleci/reflect-front/pages/legal-reports/[legalReport]/edit.vue").then(m => m.default || m)
  },
  {
    name: "legal-reports-legalReport",
    path: "",
    component: () => import("/home/circleci/reflect-front/pages/legal-reports/[legalReport]/index.vue").then(m => m.default || m)
  },
  {
    name: "legal-reports-legalReport-preview",
    path: "preview",
    meta: preview4onafmjZO2Meta || {},
    component: () => import("/home/circleci/reflect-front/pages/legal-reports/[legalReport]/preview.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "legal-reports",
    path: "/legal-reports",
    meta: indexZHnjBIMOqBMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/legal-reports/index.vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    meta: indexHyN35IpB1cMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: "login-sso",
    path: "/login/sso",
    meta: ssoKYroWS8zycMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/login/sso.vue").then(m => m.default || m)
  },
  {
    name: "reset-password-change-email",
    path: "/reset-password/change/:email()",
    meta: _91email_936xHEBDagKuMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/reset-password/change/[email].vue").then(m => m.default || m)
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: indexcBFBuzoMndMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/reset-password/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-data-health",
    path: "/settings/data-health",
    meta: indexK5SAeq8IBVMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/settings/data-health/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-data-mapping",
    path: "/settings/data-mapping",
    meta: indexra9eR3D3K4Meta || {},
    component: () => import("/home/circleci/reflect-front/pages/settings/data-mapping/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-data-normalization",
    path: "/settings/data-normalization",
    meta: indexYWywmgAyP3Meta || {},
    component: () => import("/home/circleci/reflect-front/pages/settings/data-normalization/index.vue").then(m => m.default || m)
  },
  {
    name: "settings",
    path: "/settings",
    meta: indexSgNQroCHreMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/settings/index.vue").then(m => m.default || m)
  },
  {
    name: integrationsS6r8LFTf3YMeta?.name,
    path: "/settings/integrations",
    meta: integrationsS6r8LFTf3YMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/settings/integrations.vue").then(m => m.default || m),
    children: [
  {
    name: "settings-integrations",
    path: "",
    meta: index4bqKTtyFqMMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/settings/integrations/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-integrations-sources-sourceId",
    path: "sources/:sourceId()",
    meta: _91sourceId_93Xqxb6Vh4sfMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/settings/integrations/sources/[sourceId].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "settings-my-account-preferences",
    path: "/settings/my-account/preferences",
    meta: preferences6CoJN9CK1dMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/settings/my-account/preferences.vue").then(m => m.default || m)
  },
  {
    name: "settings-my-account-profile",
    path: "/settings/my-account/profile",
    meta: profilewjwOprCpePMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/settings/my-account/profile.vue").then(m => m.default || m)
  },
  {
    name: "settings-permissions-access-roles",
    path: "/settings/permissions/access-roles",
    meta: access_45rolescfwvH074KbMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/settings/permissions/access-roles.vue").then(m => m.default || m)
  },
  {
    name: "settings-permissions-data-sensitivity",
    path: "/settings/permissions/data-sensitivity",
    meta: data_45sensitivityI393D5VQHMMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/settings/permissions/data-sensitivity.vue").then(m => m.default || m)
  },
  {
    name: "settings-permissions-source-ownership",
    path: "/settings/permissions/source-ownership",
    meta: source_45ownershipaVM5FWAbupMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/settings/permissions/source-ownership.vue").then(m => m.default || m)
  },
  {
    name: "settings-users",
    path: "/settings/users",
    meta: indexYZmQJ5xQ2oMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/settings/users/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-workspace-preferences",
    path: "/settings/workspace/preferences",
    meta: preferencesu15mKM698IMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/settings/workspace/preferences.vue").then(m => m.default || m)
  },
  {
    name: "settings-workspace-renaming",
    path: "/settings/workspace/renaming",
    meta: renamingTfPLK27slFMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/settings/workspace/renaming.vue").then(m => m.default || m)
  },
  {
    name: "signup-confirm-email",
    path: "/signup/confirm/:email()",
    meta: _91email_93rfBluS5gs1Meta || {},
    component: () => import("/home/circleci/reflect-front/pages/signup/confirm/[email].vue").then(m => m.default || m)
  },
  {
    name: "signup",
    path: "/signup",
    meta: indexqSwOaqIg8sMeta || {},
    component: () => import("/home/circleci/reflect-front/pages/signup/index.vue").then(m => m.default || m)
  }
]